<section class="section white-100">
  <div [ngClass]="isInside ? 'section-container-inside' : 'section-container'">
    <h2 class="section-heading mar-b-48">
      {{ _pricingData?.title }}
    </h2>
    <div class="international-sub-product-container">
      <div>
        <div
          class="product-blog-description mar-b-48 white"
          [innerHtml]="_pricingData?.content | toHtml"
        ></div>
        <div class="landing-btn">
          <a
            href="{{ _pricingData?.buttons?.[0]?.fields?.redirectLink | urlParams:queryParams}}"
            target="_self"
            class="btn btn-full"
            >{{ _pricingData?.buttons?.[0]?.fields?.buttonText }}</a
          >
        </div>
      </div>
      <div class="international-business-blog">
        <ng-container *ngFor="let row of _pricingData?.components2">
          <div class="international-business-sub white-100">
            <h5 class="efficient-payment-heading">
              <em
                class="red-label tag"
                *ngIf="row?.fields?.title === 'Emerging'"
              >
                Popular
              </em>
              {{ row?.fields?.title }}
            </h5>
            <div class="sub-pricing">
              <p class="faq-open-question">{{ row?.fields?.subTitle }}</p>
              <div class="landing-btn">
                <a
                  href="{{ row?.fields?.button?.[0]?.fields?.redirectLink | urlParams:queryParams}}"
                  class="btn btn-full"
                  >{{ row?.fields?.button?.[0]?.fields?.buttonText }}</a
                >
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
